var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.activeWindowCustomChartMsg).length > 0)?_c('div',{staticClass:"toolOperation"},[_c(_vm.currentTool(),{tag:"component",attrs:{"activeWindowCustomChartMsg":_vm.activeWindowCustomChartMsg},on:{"setCustomWindowChart":_vm.setCustomWindowChart}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }